import type { TypographyProps } from "@bonusx-global/bx-design-system";
import { Typography } from "@bonusx-global/bx-design-system";
import { styled } from "@mui/material";
import Grid from "@mui/material/Grid";
import type { GridProps } from "@mui/system";
import { memo } from "react";

export interface SectionTitleProps extends GridProps {
  title?: string;
  paddingBottom?: string;
  paddingTop?: string;
  isMobile: boolean;
  variant?: TypographyProps["variant"];
}

const StyledGrid = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "isMobile",
})<SectionTitleProps>(({ theme, paddingBottom, paddingTop, isMobile }) => {
  const MOBILE_CUSTOM_PADDING_BOTTOM = isMobile ? theme.spacing(6) : theme.spacing(8);

  return {
    paddingBottom: paddingBottom ?? MOBILE_CUSTOM_PADDING_BOTTOM,
    paddingTop: paddingTop,
  };
});

function generateSectionTitle({ title, variant = "h4", isMobile, ...props }: Readonly<SectionTitleProps>): JSX.Element {
  return (
    <StyledGrid item xs={12} isMobile={isMobile} {...props}>
      <Typography color="textPrimary" variant={variant}>
        {title}
      </Typography>
    </StyledGrid>
  );
}

const SectionTitle = memo(generateSectionTitle);
export default SectionTitle;
